import React, { useState, useEffect } from "react";
import "../.././Style/AboutUs/AboutUs.scss";
import "../.././Style/Admission/Admission.scss";
import "../.././Style/News&Events/Events.scss";
import axios from "axios";
import Marquee from "react-fast-marquee";
import LoadingScreen from "react-loading-screen";
import ModalImage from "react-modal-image";

// Featured Events Data
const featuredEvents = [
  {
    id: 1,
    title: "3T–IBHSc Bioethics Course at Sharda University",
    subtitle: "Report of the Workshop held at Sharda University",
    date: "22nd - 24th September 2025",
    location: "Sharda University, Greater Noida",
    images: [
      "/Sharda/word_media_image1.png",
      "/Sharda/word_media_image2.jpeg",
      "/Sharda/word_media_image3.png",
      "/Sharda/word_media_image4.jpeg",
      "/Sharda/word_media_image5.jpeg",
      "/Sharda/word_media_image6.jpeg",
      "/Sharda/word_media_image7.jpeg",
      "/Sharda/word_media_image8.jpeg",
      "/Sharda/word_media_image9.jpeg",
    ],
    description: [
      "The Department of Education, International Chair in Bioethics (UNESCO Chair in Bioethics), organised the 3T–IBHSc Bioethics Course at Sharda University, Greater Noida, from 22nd to 24th September 2025 from 9:00 am to 5:00 pm.",
      "The course, directed by Prof. Dr. Russell F. D'Souza, Dr. Nirupma Gupta, and Dr. Anusha Gupta Devra, aimed to train medical, dental and nursing faculty to integrate bioethics into their teaching.",
      "Based on the 15 principles of UNESCO's Universal Declaration on Bioethics and Human Rights (2005), the program used interactive methods such as role-plays, debates, and case-based discussions.",
      "Renowned international and national faculty contributed to the sessions, emphasizing ethical awareness, empathy, and professionalism in healthcare education.",
      "The program successfully strengthened the participants' capacity to teach and promote bioethics in health sciences, reaffirming Sharda University's and UNESCO's commitment to ethical healthcare education.",
      "The participants responded positively and were pleased with the learning experience. They appreciated the faculty and thanked them for the quality of the sessions.",
    ],
  },
  {
    id: 2,
    title: "3T Training Program at Atal Bihari Vajpayee University",
    subtitle: "Report on the 3T Training Program at Atal Bihari University, Lucknow",
    date: "18th - 20th September 2025",
    location: "Atal Bihari Vajpayee University, Lucknow",
    images: [
      "/AtalBihari/word_media_image1.jpeg",
      "/AtalBihari/word_media_image2.jpeg",
      "/AtalBihari/word_media_image3.jpeg",
      "/AtalBihari/word_media_image4.jpeg",
      "/AtalBihari/word_media_image5.jpeg",
      "/AtalBihari/word_media_image6.jpeg",
      "/AtalBihari/word_media_image7.jpeg",
      "/AtalBihari/word_media_image8.jpeg",
      "/AtalBihari/word_media_image9.jpeg",
      "/AtalBihari/word_media_image10.jpeg",
      "/AtalBihari/word_media_image11.jpeg",
      "/AtalBihari/word_media_image12.jpeg",
      "/AtalBihari/word_media_image13.jpeg",
      "/AtalBihari/word_media_image14.jpeg",
    ],
    description: [
      "A three-day workshop was successfully conducted at Atal Bihari Vajpayee University, Lucknow, from 18th September 2025 to 20th September 2025. The 3T Training Program brought together participants from various medical departments, fostering an environment of capacity building, skill enhancement, and collaborative learning.",
      "The workshop featured interactive presentations, group discussions, and hands-on activities that encouraged active engagement with the resource persons. The sessions covered a wide range of topics, including the principles of the UNESCO Declaration, AI case studies, professionalism, effective communication, strategic planning, and problem-solving techniques.",
      "On the third day, participants conducted simulated teaching sessions, which were evaluated by the invited speakers. This provided a valuable opportunity for practical application of the concepts learned during the workshop.",
      "Participants expressed appreciation for the well-structured sessions and left satisfied after the three-day program. All the participants received a certificate of participation.",
      "Overall, the workshop was engaging, enriching, and highly productive, contributing significantly to the professional growth of all attendees.",
    ],
  },
  {
    id: 3,
    title: "Global Chair Engages with European Medical Educators at AMSE 2025",
    subtitle: "Association of Medical Schools in Europe (AMSE) Conference 2025",
    date: "16th - 18th October 2025",
    location: "Palacky University of Olomouc, Czech Republic",
    images: [
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.46.58.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.47.01.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.47.07.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.48.40.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.48.45.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.48.46.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.48.51.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.48.57.jpeg",
      "/AMSE/WhatsApp%20Image%202025-12-09%20at%2023.49.00.jpeg",
    ],
    description: [
      "The Global Chair in Bioethics, Medical and Health Professions Education was pleased to participate actively in the Association of Medical Schools in Europe (AMSE) Conference 2025, held from the 16th to the 18th of October at the Palacky University of Olomouc in the Czech Republic.",
      "This prominent annual forum, which brings together leaders and educators from medical schools across the continent, provided a significant platform for the Global Chair to advance its core mission. We contributed substantively to the conference programme by leading focused sessions on contemporary curriculum reform and the strategic integration of Bioethics into medical and health professions education.",
      "Our presentations and discussions emphasised the critical need to develop future healthcare professionals who are not only clinically competent but also ethically attuned and socially responsible. The dialogue centred on practical frameworks for embedding ethical reasoning, humanism, and professionalism into core curricula, thereby equipping the next generation to navigate the complex non-medical dimensions of patient care and health systems.",
      "The ongoing collaboration between the Global Chair and AMSE is further strengthened by the role of Professor Russel DeSouza (the Chair), Prof Mary Mathew (the Co-Chair), Professor Harm Peter, President of AMSE, who serves as the European Co-Chair of the Global Chair initiative and Dr. Fateh Ramzi (the President of Students Association of the Chair). This synergistic leadership underscores a shared, profound commitment to fostering bioethical literacy and professional values across medical education in Europe and beyond.",
      "The insights exchanged at AMSE 2025 will directly inform the Global Chair's ongoing projects and resources, as we continue to work with our global network to shape a more ethically grounded future for healthcare education.",
    ],
  },
];

function EventCard({ event }) {
  return (
    <div className="event-card">
      <div className="event-header">
        <h2 className="event-title">{event.title}</h2>
        <p className="event-subtitle">{event.subtitle}</p>
        <div className="event-meta">
          <span className="event-date">
            <i className="far fa-calendar-alt"></i> {event.date}
          </span>
          <span className="event-location">
            <i className="fas fa-map-marker-alt"></i> {event.location}
          </span>
        </div>
      </div>

      <div className="event-gallery">
        <h3 className="gallery-title">Event Gallery</h3>
        <div className="gallery-grid">
          {event.images.map((image, index) => (
            <div className="gallery-item" key={index}>
              <ModalImage
                small={image}
                large={image}
                alt={`${event.title} - Image ${index + 1}`}
                className="gallery-image"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="event-description">
        <h3 className="description-title">About the Event</h3>
        {event.description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}

function Admission() {
  const [events, setEvents] = useState([]);
  const [notice, setNotice] = useState([]);
  const [mous, setMous] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAnnouncements = async () => {
    await axios.get("https://unesco-backend.vercel.app/news").then((res) => {
      const data = res.data;
      setAnnouncements(data);
    });
  };

  const getNotice = async () => {
    await axios.get("https://unesco-backend.vercel.app/notice").then((res) => {
      const data = res.data;
      setNotice(data);
    });
  };

  const getEvents = async () => {
    setLoading(true);
    await axios
      .get("https://unesco-backend.vercel.app/upcomingevent")
      .then((res) => {
        const data = res.data;
        setEvents(data);
      });
    setLoading(false);
  };

  const getMous = async () => {
    setLoading(true);
    await axios.get("https://unesco-backend.vercel.app/mou").then((res) => {
      const data = res.data;
      setMous(data);
    });
    setLoading(false);
  };

  function fetchData() {
    getNotice();
    getEvents();
    getMous();
    getAnnouncements();
  }

  useEffect(() => fetchData(), []);

  return (
    <div id="Admission" className="aboutHead">
      <LoadingScreen
        loading={loading}
        bgColor="#ffffff"
        spinnerColor="#01471B"
        textColor="#01471B"
        logoSrc="https://res.cloudinary.com/unesco-admin/image/upload/v1645289463/image003-removebg-preview_dkzzc8.png"
        text="Loading..."
      ></LoadingScreen>

      <div className="acontent">
        <div className="marquee-sibling">News</div>
        <Marquee gradient={false} pauseOnHover={true}>
          {announcements.length > 0
            ? announcements.map((value, index) => {
                return <li key={index}>{value.newshead}</li>;
              })
            : null}
        </Marquee>
      </div>

      <div>
        <h1>Events</h1>
        
        {/* Featured Events */}
        {featuredEvents.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}

        {/* Other Events from API */}
        {events.length > 0
          ? events.map((value, index) => {
              return index % 2 === 0 ? (
                <div className="adm-box" key={index}>
                  <div className="procedure">
                    <h4>{value.upeventsHead}</h4>
                  </div>
                  <div className="procedure-con">
                    <p>{value.upeventsDes}</p>
                  </div>
                </div>
              ) : (
                <div className="adm-box2" key={index}>
                  <div className="procedure-con">
                    <p>{value.upeventsDes}</p>
                  </div>
                  <div className="procedure2">
                    <h4>{value.upeventsHead}</h4>
                  </div>
                </div>
              );
            })
          : null}

        <h1>News</h1>
        {notice.length > 0
          ? notice.map((value, index) => {
              return index % 2 === 0 ? (
                <div className="adm-box" key={index}>
                  <div className="procedure">
                    <h4>{value.noticeHead}</h4>
                  </div>
                  <div className="procedure-con">
                    <p>{value.noticeDes}</p>
                  </div>
                </div>
              ) : (
                <div className="adm-box2" key={index}>
                  <div className="procedure-con">
                    <p>{value.noticeDes}</p>
                  </div>
                  <div className="procedure2">
                    <h4>{value.noticeHead}</h4>
                  </div>
                </div>
              );
            })
          : null}

        <h1>Official MoUs</h1>

        {mous.length > 0
          ? mous.map((value, index) => {
              return (
                <div className="adm-box" key={index}>
                  <div className="procedure">
                    <h4>{value.head}</h4>
                  </div>
                  <div className="procedure-con">
                    <p>{value.description}</p>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
}

export default Admission;
